const SkillList = () => {
  const skills = [
    { HTML: [] },
    { CSS: ["SCSS", "Tailwind"] },
    { JavaScript: ["React"] },
    { Design: ["Figma", "PhotoShop"] },
  ];

  return (
    <ul className="w-full max-w-[350px] sm:max-w-[400px] justify-between mb-10 flex sm:w-full">
      {skills.map((skill, i) => {
        return (
          <li className="flex flex-col " key={i}>
            <h4 className="mb-1 text-sm font-semibold tracking-widest text-gray-900 dark:font-normal dark:text-highlight font-secondary">
              {Object.keys(skill)[0]}
            </h4>
            {Object.values(skill)[0].map((item, i) => (
              <span key={i} className="text-xs tracking-widest font-base ">
                {" "}
                - {item}
              </span>
            ))}
          </li>
        );
      })}
    </ul>
  );
};

export default SkillList;
